import {finder} from "@/script"

import inMemoryCacheFactory from "@/script/cache/utils"
import {queryClient} from "@/query/queryClient";
import { $axios, apiList } from '@/api'

// const inMemoryCache = new Map()

function promiseState(p) {
    const t = {};
    return Promise.race([p, t])
        .then(v => (v === t) ? "pending" : "fulfilled", () => "rejected");
}

export default {
    state: () => ({
        courses: [],
        tags: [],
        categories: [],
        activeCourseId: null,
        coursePaginationPage: 0,
        searchState: false,
        status: {
            courseContentLoading: false
        },
        //
        searchCoursesResults: [],
        searchCoursesTotal: 0,
        searchQuery: '',
        //
    }),

    mutations: {
        setAllCourseData(state, payload) {
            state.courses = payload
        },
        settags(state, payload) {
            state.tags = payload
        },
        setSearchState(state, payload) {
            state.searchState = payload
        },
        setCoursePagination(state, payload) {
            state.coursePaginationPage = payload
        },
        setCategories(state, payload) {
            state.categories.push(payload)
        },
        setActiveCourse(state, payload) {
            localStorage.setItem('activeCourse', payload)
            state.activeCourseId = payload;
        },
        //
        setSearchQuery(state, query) {
            state.searchQuery = query;
            state.coursePaginationPage = 0; // сброс страницы при новом запросе
        },
        setSearchCoursesResults(state, { courses, total }) {
            state.searchCoursesResults = courses;
            state.searchCoursesTotal = total;
        },
        //
    },

    actions: {
        filterCategoriesArrays({commit, state}, payload) {
            if (Array.isArray(payload)) {
                if (payload.length > 1) {
                    payload.forEach(item => {
                        //eslint-disable-next-line
                        if (!!!finder(state.categories, item, 'id')) commit('setCategories', item)
                    })
                } else {
                    //eslint-disable-next-line
                    if (!!!finder(state.categories, payload[0], 'id')) commit('setCategories', payload[0])
                }
            }
        },

        getCourses({commit}) {
            $axios({
                method: apiList.courses.getAll.method,
                params: {
                    wsfunction: apiList.courses.getAll.moodle_method
                }
            })
                .then(resp => {
                    commit('setAllCourseData', resp.data)
                })
                .catch(err => console.error(err))
        },
        getRecentCourses() {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.courses.getRecentCourses.method,
                    params: {
                        wsfunction: apiList.courses.getRecentCourses.moodle_method,
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        async searchCourses({ commit, state }, { page, query }) {
            const searchQuery = query ?? state.searchQuery;

            try {
                const resp = await $axios({
                    method: apiList.courses.searchCourses.method,
                    params: {
                        wsfunction: apiList.courses.searchCourses.moodle_method,
                    },
                    data: {
                        criterianame: 'search',
                        perpage: 10,
                        page,
                        criteriavalue: searchQuery
                    }
                });

                const { data } = resp;

                commit('setSearchCoursesResults', {
                    courses: data.courses || [],
                    total: data.total || 0
                });

                if (query !== undefined) {
                    commit('setSearchQuery', query);
                }
            } catch (err) {
                console.error('Search error', err);
                commit('setSearchCoursesResults', { courses: [], total: 0 });
            }
        },

        getCourseByCat(_, categoryid) {
            const cacheName = 'categories'

            const cache = inMemoryCacheFactory(cacheName)
            if (cache.loading[cacheName]) return cache.loading[cacheName]

            const { resolved, notfound } = cache.read([categoryid])
            if (notfound.length === 0) {
                return Promise.resolve(resolved[categoryid])
            }

            return cache.loading[cacheName] = new Promise((resolve, reject) => {
                $axios({
                    method: apiList.courses.getCourseFullInfo.method,
                    params: {
                        wsfunction: apiList.courses.getCourseFullInfo.moodle_method,
                        field: 'category',
                        value: categoryid
                    }
                })
                    .then(resp => {
                        cache.save({ [categoryid]: resp.data })
                        resolve(resp.data)
                    }).catch(err => {
                        cache.stop()
                        reject(err)
                })
            })
        },


        /**
         * @description Сам по себе moodle не отдает категорию можно получить ее только по id уже относительно курса
         */
        getCategoryByCourses({dispatch}, payload) {
            const id = payload;

            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.courses.getCategoryByCourses.method,
                    params: {
                        wsfunction: apiList.courses.getCategoryByCourses.moodle_method,
                        criteria: [
                            {
                                key: 'id',
                                value: id
                            }
                        ]
                    }
                })
                    .then(resp => {
                        resolve(resp)
                        //eslint-disable-next-line
                        if (!!resp.data[0]?.id) dispatch('filterCategoriesArrays', resp.data)
                        dispatch('getCourseGroups', id)
                    }).catch(err => reject(err))
            })
        },
        triggerCourseViewEvent(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.courses.triggerViewEvent.method,
                    params: {
                        wsfunction: apiList.courses.triggerViewEvent.moodle_method,
                    },
                    data: {
                        courseid: payload
                    }
                }).then(resp => {
                    resolve(resp.data)
                }).catch(err => reject(err))
            })
        },
        //eslint-disable-next-line
        getCourseGroups({dispatch}, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.courses.getGroupByCourses.method,
                    params: {
                        wsfunction: apiList.courses.getGroupByCourses.moodle_method,
                        courseid: payload
                    }
                }).then(resp => {
                    resp.data
                }).catch(err => reject(err))
            })
        },

        /**
         * @description Так как мудл отдает данные в своем порядке и настроить это нельзя не меняя его содержимое,
         *  придется получаться данные всех показываемых курсов (в слайдере) сразу
         */
        //eslint-disable-next-line
        getFullCourseInfo({dispatch}, { id })
        {
            return new Promise(async (resolve, reject) => {
                try {
                    const data = await queryClient.fetchQuery({
                        queryKey: [`course-info-${id}`],
                        queryFn: async () => {
                            const res = await $axios({
                                method: apiList.courses.getCourseFullInfo.method,
                                params: {
                                    wsfunction: apiList.courses.getCourseFullInfo.moodle_method,
                                    field: 'id',
                                    value: id
                                }
                            })
                            return res.data
                        },
                        staleTime: 30 * 60 * 1000, // через 30 минут кеш считается протухшим
                    })

                    resolve(data)
                } catch (err) {
                    reject(err)
                }
            })
        },

        getCourseContents(_, { id, force, options })
        {
            // const cacheName = 'course-contents'
            //
            // const cache = inMemoryCacheFactory(cacheName)
            // if (cache.loading[cacheName]) return cache.loading[cacheName]
            //
            // const { resolved, notfound } = cache.read([id], force ? 1000 : null) // ** перечитать данные из API если кеш старше... (1000 = 1 сек.)
            // if (notfound.length === 0) {
            //     return Promise.resolve(resolved[id])
            // }

            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.courses.getCourseContents.method,
                    params: {
                        wsfunction: apiList.courses.getCourseContents.moodle_method,
                    },
                    data: {
                        courseid: id,
                        options: options ?? []
                    }
                })
                    .then(resp => {
                        if (resp.data.exception) {
                            throw resp.data
                        }
                        // cache.save({ [id]: resp.data })
                        resolve(resp.data)
                    }).catch(err => {
                        // cache.stop()
                        reject(err)
                    })
            })
        },

        getCourseModuleInfo(_, payload) {
            const options = typeof payload !== 'object' ? { cmid: payload } : payload

            // if (options.courseid) {
            //     // const resp = await _.dispatch('getCourseContents', { id: options.courseid, options: [{ name: 'cmid', value: options.cmid }] })
            //     const resp = await _.dispatch('getCourseContents', { id: options.courseid, options: [{ name: 'cmid', value: options.cmid }] })
            //     console.log(resp)
            // }

            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.courses.getCourseModule.method,
                    params: {
                        wsfunction: apiList.courses.getCourseModule.moodle_method,
                        cmid: options.cmid
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },

        getUserStarredCourses()
        {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.courses.getStarredCourses.method,
                    params: {
                        wsfunction: apiList.courses.getStarredCourses.moodle_method,
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },

        toggleCourseStar(_, payload)
        {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.courses.toggleCourseStar.method,
                    params: {
                        wsfunction: apiList.courses.toggleCourseStar.moodle_method,
                    },
                    data: {
                        courses: [
                            {
                                id: payload.id,
                                favourite: payload.state
                            }
                        ]
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },

        getCourseCompletionStatus(_, payload)
        {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.courses.getCourseCompletionStatus.method,
                    params: {
                        wsfunction: apiList.courses.getCourseCompletionStatus.moodle_method,
                        courseid: payload.course,
                        userid: payload.user
                    },
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },

        getContextId(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.tool.getContextid.method,
                    params: {
                        wsfunction: apiList.tool.getContextid.moodle_method,
                        mode: payload.mode ? payload.mode : 'system',
                        id: payload.id
                    }
                })
                    .then(resp => {
                        resolve(resp.data.contextid)
                    }).catch(err => reject(err))
            })
        }

    },

    getters: {
        courses: state => state.courses,
        categoriesList: state => {

            return state.categories.map(el => {
                return {
                    ...el,
                    courses: state.courses.filter(itm => itm.categoryid === el.id)
                }
            })
        },
        searchState: state => state.searchState,
        coursePaginationPage: state => state.coursePaginationPage,
        activeCourseId: state => state.activeCourseId,
        findedCourses: (state) => ({
            courses: state.searchCoursesResults,
            total: state.searchCoursesTotal
        }),
    }
}
